import request from '@/utils/request'

export function login(data) {
  return request.post('/auth/login', data)
}

export function logout() {
  return request.post('/auth/logout')
}

export function getDashboard() {
  return request.get('/dashboard/stats')
}

export function getUsers(params) {
  return request.get('/users', { params })
}

export function saveUser(data) {
  return request.post('/users', data)
}

export function updateUser(id, data) {
  return request.put('/users/' + id, data)
}

export function deleteUser(id) {
  return request.delete('/users/' + id)
}

export function setUserStatus(id, status) {
  return request.post('/users/' + id + '/status', { status })
}

export function resetUserPassword(id, password) {
  return request.put('/users/' + id + '/password', { password })
}

export function getWhitelist(params) {
  return request.get('/users/whitelist', { params })
}

export function addWhitelist(data) {
  return request.post('/users/whitelist', data)
}

export function removeWhitelist(id) {
  return request.delete('/users/whitelist/' + id)
}

export function getClasses(params) {
  return request.get('/classes', { params })
}

export function getAllClasses() {
  return request.get('/classes/all')
}

export function saveClass(data) {
  return request.post('/classes', data)
}

export function updateClass(id, data) {
  return request.put('/classes/' + id, data)
}

export function deleteClass(id) {
  return request.delete('/classes/' + id)
}

export function assignStudents(classId, data) {
  return request.put('/classes/' + classId + '/students', data)
}

export function getFontChars(params) {
  return request.get('/font-chars', { params })
}

export function getAllFontChars() {
  return request.get('/font-chars/all')
}

export function getFontChar(id) {
  return request.get('/font-chars/' + id)
}

export function saveFontChar(data) {
  return request.post('/font-chars', data)
}

export function updateFontChar(id, data) {
  return request.put('/font-chars/' + id, data)
}

export function deleteFontChar(id) {
  return request.delete('/font-chars/' + id)
}

export function setFontCharStatus(id, status) {
  return request.post('/font-chars/' + id + '/status', { status })
}

export function getFontLibraries() {
  return request.get('/font-libraries')
}

export function saveFontLibrary(data) {
  return request.post('/font-libraries', data)
}

export function updateFontLibrary(id, data) {
  return request.put('/font-libraries/' + id, data)
}

export function deleteFontLibrary(id) {
  return request.delete('/font-libraries/' + id)
}

export function getStrokes(charId) {
  return request.get('/font-chars/' + charId + '/strokes')
}

export function saveStroke(data) {
  return request.post('/font-chars/strokes', data)
}

export function updateStroke(id, data) {
  return request.put('/font-chars/strokes/' + id, data)
}

export function deleteStroke(id) {
  return request.delete('/font-chars/strokes/' + id)
}

export function getStrokePoints(strokeId) {
  return request.get('/font-chars/strokes/' + strokeId + '/points')
}

export function saveStrokePoints(strokeId, data) {
  return request.post('/font-chars/strokes/' + strokeId + '/points', data)
}

export function getWritingRecords(params) {
  return request.get('/writing/admin/records', { params })
}

export function getWritingRecordsEnriched(params) {
  return request.get('/writing/admin/records/enriched', { params })
}

export function getWritingRecord(id) {
  return request.get('/writing/admin/records/' + id)
}

export function getRecordPoints(id) {
  return request.get('/writing/records/' + id + '/points')
}

export function getScoringResult(recordId) {
  return request.get('/scoring/result/' + recordId)
}

export function getScoringResultById(id) {
  return request.get('/scoring/admin/results/' + id)
}

export function reScore(recordId) {
  return request.post('/scoring/re-score/' + recordId)
}

export function getWritingComparison(recordId) {
  return request.get('/writing/records/' + recordId + '/comparison')
}

export function getHomeworkList(params) {
  return request.get('/homework', { params })
}

export function saveHomework(data) {
  return request.post('/homework', data)
}

export function updateHomework(id, data) {
  return request.put('/homework/' + id, data)
}

export function deleteHomework(id) {
  return request.delete('/homework/' + id)
}

export function publishHomework(id) {
  return request.put('/homework/' + id + '/publish')
}

export function getHomeworkSubmits(id, params) {
  return request.get('/homework/' + id + '/submits', { params })
}

export function getExamQuestions(params) {
  return request.get('/exam/questions', { params })
}

export function addExamQuestion(data) {
  return request.post('/exam/questions', data)
}

export function deleteExamQuestion(id) {
  return request.delete('/exam/questions/' + id)
}

export function getExamConfigs(params) {
  return request.get('/exam/configs', { params })
}

export function saveExamConfig(data) {
  return request.post('/exam/configs', data)
}

export function updateExamConfig(id, data) {
  return request.put('/exam/configs/' + id, data)
}

export function deleteExamConfig(id) {
  return request.delete('/exam/configs/' + id)
}

export function getCourses(params) {
  return request.get('/courses', { params })
}

export function saveCourse(data) {
  return request.post('/courses', data)
}

export function updateCourse(id, data) {
  return request.put('/courses/' + id, data)
}

export function deleteCourse(id) {
  return request.delete('/courses/' + id)
}

export function getVideos(params) {
  return request.get('/videos', { params })
}

export function saveVideo(data) {
  return request.post('/videos', data)
}

export function updateVideo(id, data) {
  return request.put('/videos/' + id, data)
}

export function deleteVideo(id) {
  return request.delete('/videos/' + id)
}

export function getRoles(params) {
  return request.get('/roles', { params })
}

export function getAllRoles() {
  return request.get('/roles/all')
}

export function saveRole(data) {
  return request.post('/roles', data)
}

export function updateRole(id, data) {
  return request.put('/roles/' + id, data)
}

export function deleteRole(id) {
  return request.delete('/roles/' + id)
}

export function getRoleMenus(id) {
  return request.get('/roles/' + id + '/menus')
}

export function assignRoleMenus(id, menuIds) {
  return request.put('/roles/' + id + '/menus', menuIds)
}

export function getMenuTree() {
  return request.get('/menus/tree')
}

export function getMenus() {
  return request.get('/menus')
}

export function saveMenu(data) {
  return request.post('/menus', data)
}

export function updateMenu(id, data) {
  return request.put('/menus/' + id, data)
}

export function deleteMenu(id) {
  return request.delete('/menus/' + id)
}

export function getScoringParams() {
  return request.get('/configs/scoring')
}

export function updateConfigs(data) {
  return request.put('/configs', data)
}

export function getPermissions() {
  return request.get('/auth/permissions')
}

export function getUserMenus() {
  return request.get('/auth/menus')
}

export function getSystemConfigs() {
  return request.get('/configs', { params: { type: 'system' } })
}

export function updateSystemConfigs(data) {
  return request.put('/configs', data)
}

export function getApiLogs(params) {
  return request.get('/api-logs', { params })
}

export function getScheduledTaskStatus() {
  return request.get('/scheduled-tasks')
}

export function startScheduledTask(name) {
  return request.post('/scheduled-tasks/' + name + '/start')
}

export function pauseScheduledTask(name) {
  return request.post('/scheduled-tasks/' + name + '/pause')
}

export function getPumaLogs(params) {
  return request.get('/puma-logs', { params })
}

export function executeScheduledTask(name) {
  return request.post('/scheduled-tasks/' + name + '/execute')
}

// ---- 导入 ----
export function previewImport(data, params) {
  return request.post('/import/preview', data, { params })
}

export function uploadExcel(type, file, params) {
  const formData = new FormData()
  formData.append('type', type)
  formData.append('file', file)
  return request.post('/import/excel', formData, { params })
}

export function getImportPreview(type, importId, params) {
  return request.get('/import/preview/' + type + '/' + importId, { params })
}

export function confirmImport(data) {
  return request.post('/import/confirm', data)
}

// ---- 铺码 ----
export function uploadSmallPdf(file) {
  const formData = new FormData()
  formData.append('file', file)
  return request.post('/puma/upload-small-pdf', formData)
}

export function uploadPdfFromUrl(url) {
  return request.post('/puma/upload-from-url', { url })
}

export function insertPdfInfo(data) {
  return request.post('/puma/insert-pdf-info', data)
}

export function coverMask(data) {
  return request.post('/puma/cover-mask', data)
}

export function downloadBgp(data) {
  return request.post('/puma/download-bgp', data, { responseType: 'blob' })
}

export function downloadMaskedPdf(data) {
  return request.post('/puma/download-pdf-file', data, { responseType: 'blob' })
}

export function maskProgress(taskId) {
  return request.get('/puma/mask-progress', { params: { taskId } })
}

export function getOneMask(id) {
  return request.get('/puma/mask-record', { params: { id } })
}

export function getMarksNormal(params) {
  return request.get('/puma/marks', { params })
}

export function downloadMarksJson(md5) {
  return request.get('/puma/marks/download', { params: { md5 } })
}

// ---- 铺码文件工作流 ----
export function getPumaFiles(params) {
  return request.get('/puma/files', { params })
}

export function uploadPumaFile(file, remark) {
  const formData = new FormData()
  formData.append('file', file)
  if (remark) formData.append('remark', remark)
  return request.post('/puma/files', formData)
}

export function uploadPumaFileToPuma(id) {
  return request.post('/puma/files/' + id + '/upload-to-puma')
}

export function coverMaskPumaFile(id, params) {
  return request.post('/puma/files/' + id + '/cover-mask', params || {})
}

export function checkPumaFileProgress(id) {
  return request.get('/puma/files/' + id + '/progress')
}

export function fetchPumaFileAnnotations(id) {
  return request.post('/puma/files/' + id + '/fetch-annotations')
}

export function savePumaFileBaseImage(id) {
  return request.post('/puma/files/' + id + '/save-base-image')
}

// ---- 字帖生成 ----
export function previewGridSheet(data) {
  return request.post('/grid-sheets/preview', data)
}
export function generateGridSheet(data) {
  return request.post('/grid-sheets/generate', data)
}
export function getGridSheets(params) {
  return request.get('/grid-sheets', { params })
}
export function deleteGridSheet(id) {
  return request.delete('/grid-sheets/' + id)
}
export function transferGridSheet(id) {
  return request.post('/grid-sheets/' + id + '/transfer')
}
// ---- 文件上传 ----
export function uploadFile(file) {
  const formData = new FormData()
  formData.append('file', file)
  return request.post('/files/upload', formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  })
}
